import { useEffect, useState } from "react";
import { realEstateAPI } from "services/swagger-api/realEstateAPI";

/** Types de biens (TypeBienImmobilierEnum) présents dans le parc — pour n'afficher que les chips utiles. */
export const useParcBienTypes = (riskId: string | undefined): number[] => {
  const [types, setTypes] = useState<number[]>([]);

  useEffect(() => {
    if (!riskId) return;
    let cancelled = false;
    realEstateAPI
      .getParcBienTypes({ riskId })
      .then((r) => {
        if (!cancelled) setTypes(r.types ?? []);
      })
      .catch(() => {
        if (!cancelled) setTypes([]);
      });
    return () => {
      cancelled = true;
    };
  }, [riskId]);

  return types;
};
